module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "title": "Dedication"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("For the shining ones who donned their best garb and entered the Split Worlds via the mundane city of Bath on the 7th of May, 2016, and for the incredible souls who helped to weave that magical day around them.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66c554e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FM3_Dedication.vue
// module id = 66
// module chunks = 0